 <div class="container" *ngIf="this.data.operatorKey === this.OPERATORS.CAPELLA">
  <div class="card">
    <div class="task-head">
      <h4>Required!</h4>
    </div>
    <div class="icon">
      <p class="para">
         Please enter the collection start time and end time for {{ displayTextPopup }}.
      </p>
    </div>
  </div>
  <div class="popup-container">
    <form class="form-vertical" fxLayout="column" fxLayoutGap="10px" [formGroup]="capellaFormGroup">
      <div class="formDetails" style="margin: 0 0 20px 0; width: 100%;">
        <mat-label class="card-label">Collection Time (24hrs)</mat-label>
        <div fxLayout="row" fxLayoutGap="11px">
          <mat-form-field appearance="outline" class="option">
            <input matInput formControlName="collectionStart" placeholder="0 hrs" class="matOptionDate" type="text" inputmode="numeric" #inputField (input)="onNumberInput($event, 'collectionStart')"/>
          </mat-form-field>
          <span class="max-min" style="padding-top: 20px;">-</span>
          <mat-form-field appearance="outline" class="option">
            <input matInput formControlName="collectionEnd" placeholder="24 hrs" class="matOptionDate" type="text"
            [min]="firstInput + 1" #inputField (focus)="onInputFocus('end')" (blur)="onInputBlur('end')" inputmode="numeric" (input)="onNumberInput($event, 'collectionEnd')"/>
          </mat-form-field>
        </div>

        <div class="error-container">

        <span class="error-message"
            *ngIf="
            capellaFormGroup.get('collectionStart')?.hasError('min') ||
            capellaFormGroup.get('collectionStart')?.hasError('max') ||
            capellaFormGroup.get('collectionEnd')?.hasError('max') ||
            maxValue
            ">
            Collection start and end time is between 0 to 24
        </span>

        <span class="error-message"
            *ngIf="
            focusedInput === 'end' &&
            error &&
            !capellaFormGroup.get('collectionStart')?.hasError('min') &&
            !capellaFormGroup.get('collectionStart')?.hasError('max') &&
            !capellaFormGroup.get('collectionEnd')?.hasError('max') &&
            !maxValue
            ">
            Collection start time should not be greater than end time
        </span>

        </div>
      </div>
    </form>
  </div>
  <div class="btns" fxLayoutAlign="center center" fxLyout="row">
    <button class="custom-button" (click)="onNoClick()">Close</button>
    <button mat-stroked-button [disabled]="!capellaFormGroup.valid" 
    class="submit" (click)="onApply()">Save</button>
  </div>
</div>